<template>
    <div class="innerBox">
  
      <h2>Salvage Parts</h2>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox">
          <div class="col-12 row">
            <div class="col-md" :class="mobile ? 'pt-20' : ''">
              <label>Work Order</label>
              <MultiSelect
                v-model="filter.work_order_code"
                v-if="options.workorder"
                :options="options.workorder"
                placeholder="Pilih Work Order"
              ></MultiSelect>
            </div>
            <div class="col-md" :class="mobile ? 'pt-20' : ''">
              <label>Asuransi</label>
              <MultiSelect
                v-model="filter.insurance_company_name"
                v-if="options.insurance"
                :options="options.insurance.map(x => x.name)"
                placeholder="Pilih Asuransi"
              ></MultiSelect>
            </div>
            <div class="col-md" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Tanggal Salvage</label>
              <flat-pickr
                v-model="selected.salvage_date"
                :config="rangeConfig"
                placeholder="Pilih Tanggal Salvage"
              ></flat-pickr>
            </div>
          </div>
          <div class="col-12 row mt-3">
                <div class="col-md-3 offset-md-9" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
                    <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
                </div>
          </div>
        </div>
      </panel>
  
      <vue-universal-table
        api_url="/api/v1/salvage-part"
        :fields="vue_universal_table.fields"
        :buttons="vue_universal_table.buttons"
        :update="vue_universal_table.update"
        :filter="filter"
        :disable_sort="true"
        @onTambahSalvagePart="modal.create = true"
        @onLiatDetailSalvage="viewDetail"
      ></vue-universal-table>
  
      <!-- MODAL STARTS -->
      

      
      <!-- MODAL ENDS -->

    </div>
  </template>
  
  <script>  

    

    export default {
      data () {
        return {
          mobile : this.isMobile(),
          modal : {
              create : false,
              edit : false,
          },
          editObj : null,
          rangeConfig: {
            mode: 'range',
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          options : {
            workorder : [],
            insurance : [],
          },
          selected : {
            date : '',
            salvage_date : '',
          },
          filter : {
            work_order_code : '',
            insurance_company_name : '',
			groupBy : true
          },
          vue_universal_table : {
            fields : [
                {
                    title : 'Work Order ID',
                    variable : 'work_order_code'
                },
                {
                    title : 'Nomor Polisi Mobil',
                    variable : 'registration'
                },
                {
                    title : 'Tipe Mobil',
                    variable : 'car_name'
                },
                {
                    title : 'Nama Asuransi',
                    variable : 'insurance_name'
                },
                {
                    title : 'Total Salvage Parts',
                    variable : 'num_of_salvage'
                },{
                    title : 'Last Salvage Date',
                    variable : 'last_salvage_date'
                }
            ],
            special_buttons : ['tambahSalvagePart'],
            buttons : [
                {
                    title : 'LiatDetailSalvage',
                    class : 'btn-outline-primary fas fa-tools'
                },
            ],
            update : 0,
          },
        }
      },
      components : {
        
      },
      mounted () {
        this.fetchFilters()
      },
      watch : {
        'selected.date'(){
          var date = this.selected.date.split(" to ");
          this.filter.start = date[0]
          this.filter.end = date[1] ? date[1] : date[0]
        },
        'selected.salvage_date'(){
          var date = this.selected.salvage_date.split(" to ");
          this.filter.salvage_date_start = date[0]
          this.filter.salvage_date_end = date[1] ? date[1] : date[0]
        }
      },
      methods : {
		viewDetail(data) {
			data = JSON.parse(data)
			this.$router.push({name : 'SalvagePartsDetail' , params : {form_code : data.work_order_code, insurance_company : data.insurance_name}})
		},
        async fetchFilters(){
          this.options.workorder = await this.getWorkOrderCode();
          this.options.insurance = await this.getInsuranceCompany();
        }
      }
    }
  </script>
  
  <style scoped>
  
  </style>